<template>
  <component
    :is="tag"
    :class="{
      'configurator-add-to-cart-ui-step--idle': status === StepStatus.IDLE,
      'configurator-add-to-cart-ui-step--pending':
        status === StepStatus.PENDING,
      'configurator-add-to-cart-ui-step--success': status === StepStatus.DONE,
      'configurator-add-to-cart-ui-step--error': status === StepStatus.ERROR,
    }"
    class="configurator-add-to-cart-ui-step"
  >
    <span class="configurator-add-to-cart-ui-step__status">
      <slot name="status">
        <LgfSpinner
          v-if="status === StepStatus.PENDING"
          class="configurator-add-to-cart-ui-step__spinner"
        />
        <span
          v-else
          :class="{
            // 'configurator-add-to-cart-ui-step__status-icon--idle':
            //   status === StepStatus.IDLE,
            'configurator-add-to-cart-ui-step__status-icon--success':
              status === StepStatus.DONE,
            'configurator-add-to-cart-ui-step__status-icon--error':
              status === StepStatus.ERROR,
          }"
          class="configurator-add-to-cart-ui-step__status-icon"
        ></span>
      </slot>
    </span>

    <span class="configurator-add-to-cart-ui-step__label">
      <slot>
        {{ label }}
      </slot>
    </span>
  </component>
</template>

<script>
import LgfSpinner from '../LgfSpinner';

export const StepStatus = Object.freeze({
  IDLE: 0,
  PENDING: 1,
  DONE: 2,
  ERROR: -1,
});

export default {
  name: 'ConfiguratorAddToCartUiStep',
  components: { LgfSpinner },
  props: {
    tag: {
      type: String,
      default: 'div',
      validator(v) {
        return ['div', 'li'].includes(v);
      },
    },
    status: {
      type: Number,
      default: StepStatus.IDLE,
      validator(v) {
        return Object.values(StepStatus).includes(v);
      },
    },
    label: {
      type: String,
      default: undefined,
    },
  },
  data() {
    return {
      StepStatus,
    };
  },
};
</script>

<style lang="scss" scoped>
.configurator-add-to-cart-ui-step {
  $block-selector: &;
  display: flex;
  align-items: center;

  &__status {
    flex: none;
  }

  &__status-icon {
    width: 1em;
    display: block;

    @at-root %configurator-add-cart-ui-step-status-icon-before {
      @extend %icon;
      display: block;
    }

    &--success {
      color: $color-green-apple;

      &::before {
        @extend %configurator-add-cart-ui-step-status-icon-before;
        @extend %icon--check;
      }
    }

    &--error {
      color: $color-red-punch;

      &::before {
        @extend %configurator-add-cart-ui-step-status-icon-before;
        @extend %icon--close;
      }
    }
  }

  &__spinner {
    display: block;
  }

  &__label {
    flex: 1;
    min-width: 0;
    margin-left: 1em;

    #{$block-selector}--idle & {
      color: $color-gray;
    }
  }
}
</style>
